import { render, staticRenderFns } from "./AddTakeOutDemand.vue?vue&type=template&id=73fdd88b"
import script from "./AddTakeOutDemand.vue?vue&type=script&lang=js"
export * from "./AddTakeOutDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports